(function () {
  function filterSlideshowAppWebSlides() {
    var isApp = document.documentElement.classList.contains('canvas-app');

    document.querySelectorAll('.slideshow__slide[data-app-web-visibility]').forEach(function (slide) {
      var visibility = slide.getAttribute('data-app-web-visibility');
      var shouldHide = (visibility === 'web' && isApp) || (visibility === 'app' && !isApp);
      slide.toggleAttribute('hidden', shouldHide);

      if (shouldHide) {
        slide.classList.remove('is-selected');
      }
    });

    document.querySelectorAll('slideshow-carousel').forEach(function (carousel) {
      var visibleSlides = carousel.cells;
      var section = carousel.closest('[id^="shopify-section-"]');

      if (visibleSlides.length === 0) {
        if (section) {
          section.hidden = true;
        }
        return;
      }

      if (section) {
        section.hidden = false;
      }

      var selectedSlide = visibleSlides.find(function (slide) {
        return slide.classList.contains('is-selected');
      });

      if (!selectedSlide) {
        selectedSlide = visibleSlides[0];
      }

      visibleSlides.forEach(function (slide) {
        slide.classList.toggle('is-selected', slide === selectedSlide);
      });

      if (typeof carousel.select !== 'function') {
        return;
      }

      var targetIndex = visibleSlides.indexOf(selectedSlide);
      if (targetIndex < 0) {
        targetIndex = 0;
      }

      if (carousel.selectedCell !== selectedSlide) {
        carousel.select(targetIndex, { instant: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', filterSlideshowAppWebSlides);
  } else {
    filterSlideshowAppWebSlides();
  }

  document.addEventListener('shopify:section:load', filterSlideshowAppWebSlides);

  if (!document.documentElement.classList.contains('canvas-app')) {
    return;
  }

  // Stay Connected social links: open HTTPS URLs in the browser instead of
  // letting the WebView attempt a native app deep link (which toasts when uninstalled).
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.account-stay-list a[href^="http"]');
    if (!link) return;

    event.preventDefault();
    window.open(link.href, '_blank', 'noopener,noreferrer');
  }, true);
})();
